var _excluded = ["id", "shouldAllowResizing"],
    _excluded2 = ["panel"],
    _excluded3 = ["panel"],
    _excluded4 = ["isLoading", "header", "footer", "panelA", "panelB", "variant", "shouldAllowResizing", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { Divider } from '../../components';
import { Box } from '../../components/internal';
import { Group } from '../../containers';
import { Icon, Loader } from '../../foundations';
import { useBreakpoint, useBreakpointValue } from '../../theme';
import { forwardRef, useTestId } from '../../utils';
import { useMultiStyleConfig } from '../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var variantToSizeMap = {
  '2:1': {
    panelA: 66.67,
    panelB: 33.33
  },
  '1:2': {
    panelA: 33.33,
    panelB: 66.67
  },
  '1:1': {
    panelA: 50,
    panelB: 50
  }
};

var ResizeHandle = _ref => {
  var {
    id,
    shouldAllowResizing
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('SplitScreen', {});
  var dividerVariant = useBreakpointValue({
    xs: 'horizontal',
    l: 'vertical'
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: shouldAllowResizing ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      as: PanelResizeHandle,
      id: id,
      __css: styles['resizableBar']
    }, props), {}, {
      children: /*#__PURE__*/_jsx(Box, {
        as: Icon,
        type: "pause",
        size: "small",
        __css: styles['handle'],
        "aria-hidden": true
      })
    })) : /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      __css: styles['resizableBar']
    }, props), {}, {
      children: /*#__PURE__*/_jsx(Divider, {
        variant: dividerVariant
      })
    }))
  });
};

var PanelElements = _ref2 => {
  var {
    panel
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var styles = useMultiStyleConfig('SplitScreen', {
    panelPadding: panel === null || panel === void 0 ? void 0 : panel.padding
  });
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    __css: styles['panel'],
    "data-loading": (panel === null || panel === void 0 ? void 0 : panel.isLoading) || undefined
  }, props), {}, {
    children: [!(panel !== null && panel !== void 0 && panel.isLoading) && (panel === null || panel === void 0 ? void 0 : panel.header) && /*#__PURE__*/_jsx(Box, {
      __css: styles['panelHeader'],
      children: panel === null || panel === void 0 ? void 0 : panel.header
    }), panel !== null && panel !== void 0 && panel.isLoading ? /*#__PURE__*/_jsx(Loader, {}) :
    /*#__PURE__*/
    // Scrollable container should be accessible by keyboard
    // https://dequeuniversity.com/rules/axe/4.8/scrollable-region-focusable?application=axeAPI
    _jsx(Box, {
      __css: styles['panelContent'],
      tabIndex: 0,
      children: panel === null || panel === void 0 ? void 0 : panel.content
    }), !(panel !== null && panel !== void 0 && panel.isLoading) && (panel === null || panel === void 0 ? void 0 : panel.footer) && /*#__PURE__*/_jsx(Box, {
      __css: styles['panelFooter'],
      children: panel === null || panel === void 0 ? void 0 : panel.footer
    })]
  }));
};

var SmallScreensPanelElements = _ref3 => {
  var {
    panel
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var styles = useMultiStyleConfig('SplitScreen', {
    panelPadding: panel === null || panel === void 0 ? void 0 : panel.padding
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!(panel !== null && panel !== void 0 && panel.isLoading) && (panel === null || panel === void 0 ? void 0 : panel.header) && /*#__PURE__*/_jsx(Box, {
      __css: styles['panelHeader'],
      children: panel === null || panel === void 0 ? void 0 : panel.header
    }), /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      __css: styles['panelContent']
    }, props), {}, {
      tabIndex: 0,
      children: panel === null || panel === void 0 ? void 0 : panel.content
    })), !(panel !== null && panel !== void 0 && panel.isLoading) && (panel === null || panel === void 0 ? void 0 : panel.footer) && /*#__PURE__*/_jsx(Box, {
      __css: styles['panelFooter'],
      children: panel === null || panel === void 0 ? void 0 : panel.footer
    })]
  });
};

export var SplitScreen = forwardRef((_ref4, ref) => {
  var _panelA$maxWidth, _panelA$minWidth;

  var {
    isLoading,
    header,
    footer,
    panelA,
    panelB,
    variant = '1:2',
    shouldAllowResizing,
    'data-testid': dataTestId = 'split-screen'
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  var maxWidth = (_panelA$maxWidth = panelA === null || panelA === void 0 ? void 0 : panelA.maxWidth) !== null && _panelA$maxWidth !== void 0 ? _panelA$maxWidth : 66.67;
  var minWidth = (_panelA$minWidth = panelA === null || panelA === void 0 ? void 0 : panelA.minWidth) !== null && _panelA$minWidth !== void 0 ? _panelA$minWidth : 12.5;
  var styles = useMultiStyleConfig('SplitScreen', {}); // using useBreakpointValue to detect the small screens 'xs', 's', 'm'.

  var isSmallBreakpoint = useBreakpointValue({
    xs: true,
    l: false
  });
  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint({
    debounce: 0
  });
  var isSmallScreensLoading = (panelA === null || panelA === void 0 ? void 0 : panelA.isLoading) || (panelB === null || panelB === void 0 ? void 0 : panelB.isLoading);
  var getTestId = useTestId(dataTestId);

  if (isLoading) {
    return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-component": "SplitScreen",
      __css: styles['container']
    }, getTestId()), props), {}, {
      ref: ref,
      "data-loading": true,
      children: /*#__PURE__*/_jsx(Loader, {})
    }));
  }

  if (isSmallBreakpoint) {
    return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-component": "SplitScreen",
      __css: styles['container']
    }, getTestId()), props), {}, {
      ref: ref,
      children: [header, /*#__PURE__*/_jsx(Box, {
        __css: styles['panel'],
        "data-loading": isSmallScreensLoading,
        children: isSmallScreensLoading ? /*#__PURE__*/_jsx(Loader, _objectSpread({}, getTestId('loader'))) : /*#__PURE__*/_jsxs(Group, {
          variant: "vertical",
          hasDivider: true,
          spacing: isMobile ? 'xs' : 'none',
          height: "full",
          children: [/*#__PURE__*/_jsx(SmallScreensPanelElements, _objectSpread({
            panel: panelA
          }, getTestId('panel-a'))), /*#__PURE__*/_jsx(SmallScreensPanelElements, _objectSpread({
            panel: panelB
          }, getTestId('panel-b')))]
        })
      }), footer]
    }));
  }

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread(_objectSpread({
    "data-component": "SplitScreen",
    __css: styles['container']
  }, getTestId()), props), {}, {
    ref: ref,
    children: [header, /*#__PURE__*/_jsxs(PanelGroup, {
      direction: "horizontal",
      children: [/*#__PURE__*/_jsx(Panel, {
        id: "panelA",
        defaultSize: variantToSizeMap[variant].panelA,
        minSize: minWidth,
        maxSize: maxWidth,
        order: 1,
        children: /*#__PURE__*/_jsx(PanelElements, _objectSpread({
          panel: panelA
        }, getTestId('panel-a')))
      }), /*#__PURE__*/_jsx(ResizeHandle, _objectSpread({
        shouldAllowResizing: shouldAllowResizing
      }, getTestId('resize-handle'))), /*#__PURE__*/_jsx(Panel, {
        id: "panelB",
        defaultSize: variantToSizeMap[variant].panelB,
        order: 2,
        children: /*#__PURE__*/_jsx(PanelElements, _objectSpread({
          panel: panelB
        }, getTestId('panel-b')))
      })]
    }), footer]
  }));
});
SplitScreen.displayName = 'SplitScreen';
//# sourceMappingURL=SplitScreen.js.map